import {
  GET_ENGAGEMENTS_COMMENTS_REQUEST,
  GET_ENGAGEMENTS_COMMENTS_SUCCESS,
  GET_ENGAGEMENTS_COMMENTS_FAILURE,
} from 'pages/WirelineEngagements/WirelineEngagementsComments/GetComments/actionTypes';

export const getCommentsRequest = () => ({ type: GET_ENGAGEMENTS_COMMENTS_REQUEST });

export const getCommentsSuccess = (comments) => (
  { type: GET_ENGAGEMENTS_COMMENTS_SUCCESS, comments });

export const getCommentsFailure = (error) => ({ type: GET_ENGAGEMENTS_COMMENTS_FAILURE, error });
